import React from 'react';

const UnitTest = () => {
    return (
        <>
            <div className="p-3 rounded-lg shadow-lg my-2 dark:bg-white">
                <h3 className="text-[25px] font-bold">What is a unit test? Why should write unit tests?</h3>
                <p className="text-[20px] font-medium">
                    A unit test is a software testing method to test individual units of source code to determine if they are all good to be used. We use unit testing because by Unit testing we ensure that our code is quality standard to be deployed.
                </p>
            </div>
        </>
    );
};

export default UnitTest;